// extracted by mini-css-extract-plugin
export var section = "Highlight1-module--section--3b85f";